export default __webpack_public_path__ + "static/media/writing-note-svgrepo-com.26dac613.svg";